import IntegrationTaskResourceModel from '../../generated/types/model/resource/IntegrationTaskResourceModel';

export default class IntegrationTaskResourceViewModel extends IntegrationTaskResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
